import { NavLink } from 'react-router-dom';

/** Navigation across the moderator tools. */
export function ModerationNav() {
  return (
    <nav className="modnav">
      <NavLink to="/moderation" end>
        Review queue
      </NavLink>
      <NavLink to="/moderation/matching">Matching</NavLink>
      <NavLink to="/moderation/outcomes">Outcomes</NavLink>
      <NavLink to="/moderation/restricted">Restricted</NavLink>
      <NavLink to="/moderation/audit">Audit log</NavLink>
      <NavLink to="/">← App</NavLink>
    </nav>
  );
}
